module.exports = __webpack_public_path__ + "static/media/enviro_tec_logo.877b4f68.svg";